import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { ModalCtrl as r, ThemeCtrl as n, ConfigCtrl as l, OptionsCtrl as s } from "@web3modal/core";
var c = Object.defineProperty,
  i = Object.getOwnPropertySymbols,
  d = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  a = function a(o, e, t) {
    return e in o ? c(o, e, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : o[e] = t;
  },
  m = function m(o, e) {
    for (var t in e || (e = {})) d.call(e, t) && a(o, t, e[t]);
    if (i) {
      var _iterator = _createForOfIteratorHelper(i(e)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          b.call(e, t) && a(o, t, e[t]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return o;
  };
var f = /*#__PURE__*/function () {
  function f(e) {
    _classCallCheck(this, f);
    this.openModal = r.open, this.closeModal = r.close, this.subscribeModal = r.subscribe, this.setTheme = n.setThemeConfig, n.setThemeConfig(e), l.setConfig(m({
      enableStandaloneMode: !0
    }, e)), this.initUi();
  }
  _createClass(f, [{
    key: "initUi",
    value: function () {
      var _initUi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof window < "u")) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return import("@web3modal/ui");
            case 3:
              e = document.createElement("w3m-modal");
              document.body.insertAdjacentElement("beforeend", e), s.setIsUiLoaded(!0);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function initUi() {
        return _initUi.apply(this, arguments);
      }
      return initUi;
    }()
  }]);
  return f;
}();
export { f as Web3Modal };